module.exports = function() {
  return new Worker(__webpack_public_path__ + "5d1932ddb184eccac146.worker.js");
};